<template>
  <div class="cancel-reccuring-confirmation-popup">
    <popup :title="`למחוק את קטגורית ${expenseCategory} מהתזרים?`"
           :buttons="[{ title: 'כן, למחוק מהתזרים', action: cancelReccuringApproved }]"
           :close-action="closeModal">
      <template v-slot:content v-if="expenses.upToNowAmount > 0">
        <div class="content">
          ההוצאות שמופיעות עכשיו ב<span class="move-from">{{expenseCategory}}</span> יעברו ל<span class="move-to">הוצאות משתנות</span>
        </div>
      </template>
    </popup>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import { mapActions } from 'vuex';
import Segment from '../../../../../../../../../../Segment';

export default {
  name: 'CancelReccuringConfirmationPopup',
  components: {
    Popup: BaseUI.Popup,
  },
  props: {
    expenseCategory: {
      type: String,
      required: true,
    },
    expenses: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions('editCashflow', ['cancelEnvelope']),
    cancelReccuringApproved() {
      Segment.trackUserInteraction('CancelReccuringConfirmationClicked', {
        expenseCategory: this.expenseCategory,
        envelopeId: this.expenses.envelopeId,
      });
      this.cancelEnvelope(this.expenses.envelopeId);
      this.closeModal();
    },
    closeModal() {
      Segment.trackUserInteraction('CancelReccuringConfirmationCanceled', {
        expenseCategory: this.expenseCategory,
        envelopeId: this.expenses.envelopeId,
      });
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .cancel-reccuring-confirmation-popup {
    .content {
      line-height: 16px;

      .move-from {
        font-weight: bold;
        color: $riseup_light_blue;
      }

      .move-to {
        font-weight: bold;
        color: $riseup_mustard;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/current-month/components/cashflow-edit/edit-reccuring/CancelReccuringConfirmationPopup.vue